module.exports = __webpack_public_path__ + "img/horizontal_1_1_8017.cb139cc4.png";